module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23 17h-6v6h-2v-6H9v-2h6V9h2v6h6z\"></path></svg>"